import React from 'react';
import { View, StyleSheet } from 'react-native';
import {
  VictoryChart,
  VictoryAxis,
  VictoryBar,
  VictoryLabel,
  VictoryStack,
} from 'victory';
import dayjs from 'dayjs';

const BarChartAveragePerDay = ({ averageByWeekday, limitDay }) => {
  limitDay = limitDay || 0;
  const COLORS = ['rgba(134, 65, 244, 0.8)', '#8A0707'];
  const CUT_OFF = 1;

  const abbreviatedWeekdays = [...Array(7)].map((_, i) =>
    dayjs()
      .day(i + 1)
      .format('ddd')
  );
  abbreviatedWeekdays.push(dayjs().day(0).format('ddd'));

  const data = [];
  for (let i = 1; i <= 7; i++) {
    const dayIndex = i % 7;
    const units = averageByWeekday[dayIndex];
    if (units !== undefined) {
      const below = units > limitDay ? limitDay : units;
      const above = units > limitDay ? units - limitDay : 0;
      data.push({
        day: abbreviatedWeekdays[i - 1],
        below,
        above,
        total: units,
      });
    }
  }

  function CustomLabel({ x, y, datum, isAbove }) {
    // If the total is 0, don't render a label
    if (datum.total === 0) return null;

    // Only display label if it's the 'above' part or there is no 'above' part
    if (isAbove || datum.above === 0) {
      const labelY = isAbove ? y + 15 : y - 10;
      return (
        <VictoryLabel
          style={{ fill: isAbove ? 'white' : 'black', fontSize: 18 }}
          x={x}
          y={labelY}
          text={datum.total}
          dx={-5}
        />
      );
    }
    return null;
  }

  return (
    <View style={styles.chartContainer}>
      <VictoryChart>
        <VictoryAxis style={{ tickLabels: { fontSize: 20 } }} />
        <VictoryStack colorScale={COLORS}>
          <VictoryBar
            data={data}
            x="day"
            y="below"
            labels={({ datum }) => datum.total}
            labelComponent={<CustomLabel isAbove={false} />}
            barRatio={0.9}
          />
          <VictoryBar
            data={data}
            x="day"
            y="above"
            labels={({ datum }) => datum.total}
            labelComponent={<CustomLabel isAbove={true} />}
            barRatio={0.9}
          />
        </VictoryStack>
      </VictoryChart>
      <View style={styles.overlay} />
    </View>
  );
};

const styles = StyleSheet.create({
  chartContainer: {
    position: 'relative',
    flex: 1, // Adjust based on your layout needs
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'transparent', // Make sure it's invisible
  },
});

export default BarChartAveragePerDay;
